import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import {
  ReceiveDocumentGetLink,
  ReceiveDocumentGetLinkFailure,
  ReceiveDocumentGetLinkSuccess,
  ReceiveDocumentLinkActionTypes,
} from './receive-document-link.actions';
import { OrdersHistoryService } from '../../services/orders-history.service';
import { saveAs } from 'file-saver';

@Injectable()
export class ReceiveDocumentLinkEffects {
  @Effect()
  receiveLinkForDocument$ = this.actions$.pipe(
    ofType(ReceiveDocumentLinkActionTypes.RECEIVE_DOCUMENT_GET_LINK),
    map((action: ReceiveDocumentGetLink) => action.payload),
    mergeMap((params) => {
        const {id, name, type} = params;
        return this.httpOrderService.getLinkToDocumentDownload(type, id).pipe(
          map((data) => {
            return new ReceiveDocumentGetLinkSuccess({ ...data, name });
          }),
          catchError(error => of(new ReceiveDocumentGetLinkFailure({error}))),
        );
      },
    ),
  );

  @Effect({ dispatch: false })
  downloadDocument$ = this.actions$.pipe(
    ofType(ReceiveDocumentLinkActionTypes.RECEIVE_DOCUMENT_GET_LINK_SUCCESS),
    mergeMap((action: ReceiveDocumentGetLinkSuccess) => this.httpOrderService.getDocument(action.payload.url)
      .pipe(
        tap((data: any) => {
          try {
            saveAs(data, action.payload.name);
          } catch (error) {
            window.console.log(error);
          }
        }),
        catchError((error) => {
          window.console.log(error);
          return of (error);
        })
      )
    ),
  );

  constructor (private actions$: Actions,
               private httpOrderService: OrdersHistoryService) {
  }
}
